import { HTTP_TOKEN, HTTP_TOKEN_REPORT } from "./http";

export const getFunnels = (params) => {
  return HTTP_TOKEN.get("funnel", { params }).then((result) => {
    return result.data;
  });
};

export const getFunnel = (funnelId) => {
  return HTTP_TOKEN.get(`funnel/${funnelId}`).then((result) => {
    return result.data;
  });
};

export const createFunnel = (data) => {
  return HTTP_TOKEN.post("funnel", data).then((result) => {
    return result.data;
  });
};

export const updateFunnel = (funnelId, data) => {
  return HTTP_TOKEN.put(`funnel/${funnelId}`, data).then((result) => {
    return result.data;
  });
};

export const deleteFunnel = (funnelId) => {
  return HTTP_TOKEN.delete(`funnel/${funnelId}`, {}).then((result) => {
    return result.data;
  });
};

export const copyFunnel = (funnelId) => {
  return HTTP_TOKEN.post(`funnel/${funnelId}/copy`, {}).then((result) => {
    return result.data;
  });
};


// steps
export const getFunnelSteps = (funnelId, params) => {
  return HTTP_TOKEN.get(`funnel/${funnelId}/step`, { params }).then((result) => {
    return result.data;
  });
};

export const getFunnelStep = (funnelId, stepId) => {
  return HTTP_TOKEN.get(`funnel/${funnelId}/step/${stepId}`).then((result) => {
    return result.data;
  });
};


export const createFunnelStep = (funnelId, data) => {
  return HTTP_TOKEN.post(`funnel/${funnelId}/step`, data).then((result) => {
    return result.data;
  });
};

export const updateFunnelStep = (funnelId, stepId, data) => {
  return HTTP_TOKEN.put(`funnel/${funnelId}/step/${stepId}`, data).then((result) => {
    return result.data;
  });
};

export const deleteFunnelStep = (funnelId, stepId) => {
  return HTTP_TOKEN.delete(`funnel/${funnelId}/step/${stepId}`, {}).then((result) => {
    return result.data;
  });
};

// report

export const getFunnelReport = (funnelId, params) => {
  return HTTP_TOKEN_REPORT.get(`funnel/${funnelId}`, { params }).then((result) => {
    return result.data;
  });
}

// step action

// steps
export const getFunnelStepActions = (funnelId, stepId, params) => {
  return HTTP_TOKEN.get(`funnel/${funnelId}/step/${stepId}/active`, { params }).then((result) => {
    return result.data;
  });
};

export const createFunnelStepAction = (funnelId, stepId, data) => {
  return HTTP_TOKEN.post(`funnel/${funnelId}/step/${stepId}/active`, data).then((result) => {
    return result.data;
  });
};

export const updateFunnelStepAction = (funnelId, stepId, actionId, data) => {
  return HTTP_TOKEN.put(`funnel/${funnelId}/step/${stepId}/active/${actionId}`, data).then((result) => {
    return result.data;
  });
};

export const deleteFunnelStepAction = (funnelId, stepId, actionId) => {
  return HTTP_TOKEN.delete(`funnel/${funnelId}/step/${stepId}/active/${actionId}`, {}).then((result) => {
    return result.data;
  });
};
